import { render } from "./AIButton.vue?vue&type=template&id=01f86236&scoped=true"
import script from "./AIButton.vue?vue&type=script&lang=ts"
export * from "./AIButton.vue?vue&type=script&lang=ts"

import "./AIButton.vue?vue&type=style&index=0&id=01f86236&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01f86236"

export default script